module.exports = __webpack_public_path__ + "img/全部退货.78cf94d1.svg";